import { IReport } from '../../interfaces/ireport';

export class ReportBase {
  ReportId: number;
  Name: string;
  URL: string;
  Description: string | null;
  IsOperational: boolean;
  Func: string | null;
  Type: string | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  constructor(item?: IReport) {
    if (item) {

      this.ReportId = item.ReportId;
      this.Name = item.Name;
      this.URL = item.URL;
      this.Description = item.Description;
      this.IsOperational = item.IsOperational;
      this.Func = item.Func;
      this.Type = item.Type;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

    }
  }
}